import StatsDialog from './StatsDialog';

export default StatsDialog;